import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.ITEM_LAUNCHER)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const img = await getImage(item.buildInfo[0].image)

				const canvas = createCanvas(img.width, img.height)
				canvas.getContext("2d").drawImage(img, 0, 0)

				return [{
					image: await toImage(canvas),
					textureSizeOff: { x: 1, y: 1 },
					texturePosOff: { x: -0.5, y: -0.5 }
				}]
			}
		}
	}
)
